export const pxToRem = (px = 10) => {
  return `${px / 10}rem`;
};
